import axios from 'axios';

const instance = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL });

// Append token on each request
instance.interceptors.request.use(
  (config) => {
    const token: string | null = localStorage.getItem('token');
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      };
    }
    return config;
  },
  (err) => Promise.reject(err),
);

// Delete token from localStorage if status is unauthorized
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.reload();
    }
    return Promise.reject(error);
  },
);

export default instance;
